import { AxiosResponse } from 'axios'
import { http } from '../../utils'
import { Response } from '../types'
import { uploadObject } from '../user'

const IMPORT_TIMEOUT_MS = 600_000

export interface ImportChallanXlApiResponse extends Response {
  data?: unknown
}

export type ClearImportDataResponse = Response

export function importChallanFromXlsxUrl(
  xlsxUrl: string,
  finYear: string
): Promise<ImportChallanXlApiResponse> {
  return http
    .get<ImportChallanXlApiResponse>(`/dataimport/pvt/import_challan_xl`, {
      params: { xlxs_url: xlsxUrl, fin_year: finYear },
      timeout: IMPORT_TIMEOUT_MS,
    })
    .then((response: AxiosResponse<ImportChallanXlApiResponse>) => response.data)
}

export function clearImportData(): Promise<ClearImportDataResponse> {
  return http
    .post<ClearImportDataResponse>(`/dataimport/pvt/clear_import_data`, {})
    .then((response: AxiosResponse<ClearImportDataResponse>) => response.data)
}

export async function importChallanFromXlsxFile(
  file: File,
  finYear: string
): Promise<ImportChallanXlApiResponse> {
  const uploadResult = await uploadObject(file.name, file)
  const url = uploadResult.downloadUrl
  if (!url) {
    throw new Error('Upload did not return a file URL')
  }
  return importChallanFromXlsxUrl(url, finYear)
}
